<template>
	<icon-tooltip @click="openHelp">
		<slot name="multiHoverHelp" />
		<basic-inline-dialog
			ref="currentHelp"
			title="Invalid Document"
			dialog-class="faqDialog mobileFAQ"
			width="600"
			:animation="{effect:'slide', direction:'left', duration:500}"
			:state="dialogState"
			:state-namespace="dialogNamespace"	
		>
			<div class="faqDialogContent">
				<slot name="multiMobile" />
			</div>
		</basic-inline-dialog>
	</icon-tooltip>
</template>

<script>
import BasicInlineDialog from "./BasicInlineDialog.vue";
import IconTooltip from "./IconTooltip.vue";
import { isMobile } from "../../helpers/mobile.js";

const MultiHelp = {
	moduleName: `multiHelp`,
	components: {
		BasicInlineDialog,
		IconTooltip,
	},
	data() {
		return {
			dialogState: `show`,
			dialogNamespace: MultiHelp.moduleName,
		};
	},
	methods: {
		openHelp() {
			if (isMobile()) this.$refs.currentHelp.showDialog();
		},
	},
};

export default MultiHelp;
</script>